import dayjs from "dayjs";
import { useState } from "react";
import { useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "../../../../assets/icons/Spinner";
import TrashIcon from "../../../../assets/icons/TrashIcon";

import Message from "../../../../i18n/Message";

import {
  deleteAssistant,
  loadAssistant,
} from "../store/assistantActionCreators";
import { assistantSelectors } from "../store/assistantReducer";

import AssistantTitle from "./AssistantTitle";

import "./AssistantDetailsPage.scss";
import AssistantContent from "./AssistantContent";
import AssistantModelSettings from "./AssistantModelSettings";
import ChevronLeftIcon from "../../../../assets/icons/ChevronLeftIcon";
import NewWorkspaceLayout from "../../layout/NewWorkspaceLayout";
import { linkToAssistants } from "../../../../routes";

const AssistantDetailsPage = () => {
  const { assistantId, workspaceId } = useParams();
  const intl = useIntl();
  const nav = useNavigate();
  const dispatch = useDispatch();
  const assistant = useSelector(assistantSelectors.getAssistant);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  useEffect(() => {
    if (!assistant || assistant?.uid !== assistantId) {
      dispatch(loadAssistant(intl, workspaceId, assistantId));
    }
  }, [assistant, assistantId, workspaceId, dispatch, intl]);

  const onDeleteConfirmed = () => {
    const onSuccess = () => {
      setShowDeleteConfirm(false);
      nav(linkToAssistants(workspaceId));
    };
    dispatch(
      deleteAssistant(intl, workspaceId, assistantId, onSuccess, () =>
        setShowDeleteConfirm(false)
      )
    );
  };

  const item = !!assistant && assistant?.uid === assistantId ? assistant : null;

  return (
    <NewWorkspaceLayout contentPanelClassName="assistant_details_main">
      {!item && (
        <div className="spinner_container">
          <Spinner />
        </div>
      )}
      {item && (
        <>
          <div className="title_row">
            <div className="title_column">
              <div className="breadcrumbs">
                <div onClick={() => nav(linkToAssistants(workspaceId))}>
                  <ChevronLeftIcon
                    size={16}
                    strokeWidth="2"
                    color="rgb(103, 116, 142)"
                  />
                  <Message id="back_to_assistants" />
                </div>
              </div>
              <div className="title_block">
                <div className="title_left">
                  <AssistantTitle assistant={item} workspaceId={workspaceId} />
                  <div className="metadata_row">
                    <div className="meta_name">
                      <Message id="created_on" />
                    </div>
                    <div className="meta_value">
                      {dayjs(item.dateCreated).format("DD MMM")}
                    </div>
                  </div>
                </div>
                <div className="title_actions">
                  <div className="confirm_container">
                    {showDeleteConfirm && (
                      <>
                        <div
                          className="cover"
                          onClick={() => setShowDeleteConfirm(false)}
                        ></div>
                        <div className="confirm_panel">
                          <button
                            className="btn bg-gradient-primary btn-sm"
                            onClick={onDeleteConfirmed}
                          >
                            <Message id="confirm_delete" />
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                  <button
                    className="btn no-btn tile-action"
                    onClick={() => setShowDeleteConfirm(!showDeleteConfirm)}
                  >
                    <TrashIcon size="16" color="#344767" />
                    <Message id="delete" />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <AssistantContent assistant={assistant} workspaceId={workspaceId} />
          <div className="card model_settings_panel">
            <AssistantModelSettings assistant={assistant} workspaceId={workspaceId} />
          </div>
        </>
      )}
    </NewWorkspaceLayout>
  );
};

export default AssistantDetailsPage;
